import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

type TableStyleProps = {
  cellPadding: string | number;
  height: string | number;
  maxHeight: string | number;
};

export const useTableStyles = makeStyles<Theme, TableStyleProps>(theme => ({
  center: {
    textAlign: 'center',
  },
  noPadding: {
    padding: 0,
  },
  root: {
    // width: '100%',
  },
  table: {
    minWidth: '100%',
    width: 'max-content !important',
    padding: '0 2px',
  },
  tableContainer: props => ({
    height: props.height,
    maxHeight: props.maxHeight ?? 'clamp(200px, 69vh, 69vh)',
    backgroundColor: 'rgba(0, 0, 0, 0) !important',
    '& .actionBtnSmall': {
      opacity: 0.2,
      '&:hover': {
        opacity: 1,
        transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
    },
  }),
  stickyFooter: {
    '& .MuiTableCell-footer': {
      position: 'sticky',
      bottom: 0,
      zIndex: 4,
      backgroundColor: 'inherit',
    },
    '& tr': {
      zIndex: 4,
      backgroundColor: theme.palette.background.paper,
    },
  },
  leftAlignment: {
    '& .MuiTablePagination-spacer': {
      flex: 'unset',
    },
  },
}));
